import { CardSvg } from '@/play/cardSvg'

/** Home card art: goo pouring onto steps and slumping. */
export function GelCardArt() {
  return (
    <CardSvg bg="#e9f1ef">
      <rect y="150" width="320" height="50" fill="#f3efe6" />
      {/* steps */}
      <path d="M40 150 V 128 H 80 V 106 H 120 V 84 H 160 V 150 Z" fill="#e4dccf" />
      {/* slumped gobs */}
      <path d="M58 129 C 58 112, 76 112, 78 128 C 82 131, 54 131, 58 129 Z" fill="#7ee35b" />
      <path d="M118 107 C 116 88, 140 86, 144 104 C 150 110, 156 116, 158 130 C 160 138, 150 132, 148 118 C 140 110, 120 112, 118 107 Z" fill="#ff5fa2" />
      <path d="M200 150 C 196 128, 236 126, 240 150 Z" fill="#3fb8ff" />
      {/* a rope of goo pouring down onto a growing heap */}
      <path d="M256 0 C 252 40, 262 80, 258 118 C 256 132, 262 140, 262 146 L 270 146 C 270 138, 274 128, 272 116 C 270 80, 278 40, 274 0 Z" fill="#ffb21f" />
      <path d="M232 150 C 236 136, 250 128, 266 128 S 296 136, 300 150 Z" fill="#ffb21f" />
      <ellipse cx="262" cy="40" rx="3" ry="12" fill="#ffffff" opacity="0.5" />
    </CardSvg>
  )
}
